// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/analytics_dashboard/:app_group_id/sms_credit_consumption_detail_data" endpoint
 */

import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { smsMmsConsumption } from "./constants";
import type { SmsMmsConsumptionParams, SmsMmsConsumptionResult } from "./types";
import { isSmsMmsConsumptionResult } from "./validators";

export const getDataTableSmsMmsConsumption = reactQueryTableFetcherAdapter(
  smsMmsConsumption,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 20, start = 0, sortdir, sortby }: SmsMmsConsumptionParams
  ): Promise<SmsMmsConsumptionResult> => {
    const { start_date, end_date, sms_type: smsType, direction: direction, country } = query;

    return fetch(
      `/analytics_dashboard/${appGroupId}/sms_credit_consumption_detail_data`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        start_date: start_date,
        end_date: end_date,
        query: serializeQueryObjects({
          ...(smsType && { sms_type: smsType }),
          ...(direction && { direction: direction }),
          ...(country && { country: country }),
        }),
      },
      { signal }
    );
  },
  isSmsMmsConsumptionResult
);
